import { Button } from '@toggle/design-system';
import React, { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { ModalTypes, useModal } from '~/hooks/use-modal/useModal';
import { FiltersPanel } from '~/views/screener/filters-panel/FiltersPanel';

import { AssistantConditions } from '../assistant-conditions/AssistantConditions';
import { ConditionsFilters } from '../conditions-filters/ConditionsFilters';
import styles from './ScenarioFilters.module.scss';
import * as S from './ScenarioFilters.styles';

export interface ScenarioFiltersProps {
  filtersChildren?: ReactNode;
  onEditAssistantCondition?: (filterKey: string) => void;
  resetAskedQuestions(): void;
}

export const ScenarioFilters = ({
  filtersChildren,
  onEditAssistantCondition,
  resetAskedQuestions,
}: ScenarioFiltersProps) => {
  const { t } = useTranslation('scenario');
  const { open } = useModal(ModalTypes.AddCondition);

  const onAddAnotherCondition = () => {
    open();
    resetAskedQuestions();
  };

  return (
    <FiltersPanel
      title={t('scenario:scenarioConditions')}
      data-testid="scenario-filters"
    >
      <S.HeaderWrapper>
        <S.FiltersWrapper>
          <ConditionsFilters />
          <AssistantConditions
            onEditAssistantCondition={onEditAssistantCondition}
          />

          <Button
            className={styles.dashedButton}
            data-testid="add-another-condition-btn"
            size="small"
            variant="secondary"
            label={t('scenario:filters.addAnotherCondition')}
            iconPosition="right"
            iconName="Alfred"
            onClick={onAddAnotherCondition}
          />
        </S.FiltersWrapper>

        {filtersChildren}
      </S.HeaderWrapper>
    </FiltersPanel>
  );
};
